import { BRAND } from '../config/brand';

export const NAVY = BRAND.colors.navy;
export const NAVY_DARK = BRAND.colors.navyDark;
export const NAVY_RGB = '27, 77, 137';

export const getNavItemSx = (level: number, isActive = false) => ({
  mx: 1,
  mb: 0.5,
  borderRadius: 2,
  pl: 2 + (level > 0 ? 32 * level : 0),
  pr: 2,
  color: 'text.primary',
  backgroundColor: isActive
    ? `rgba(${NAVY_RGB}, ${level === 0 ? 0.12 : 0.16})`
    : level > 0
      ? `rgba(${NAVY_RGB}, 0.06)`
      : 'transparent',
  '&:hover': {
    backgroundColor: `rgba(${NAVY_RGB}, ${level === 0 ? 0.08 : 0.12})`,
    '& .MuiListItemIcon-root': {
      color: NAVY,
    },
    '& .MuiListItemText-primary': {
      color: NAVY,
      fontWeight: 600,
    },
  },
  '&.Mui-selected': {
    backgroundColor: `rgba(${NAVY_RGB}, ${level === 0 ? 0.12 : 0.16})`,
    '& .MuiListItemIcon-root': {
      color: NAVY,
    },
    '& .MuiListItemText-primary': {
      color: NAVY,
      fontWeight: 600,
    },
  },
});

export const getNavIconSx = (level: number) => ({
  color: level === 0 ? NAVY_DARK : NAVY,
  minWidth: 40,
});

export const getNavTextProps = (level: number) => ({
  fontSize: level === 0 ? '0.95rem' : '0.875rem',
  fontWeight: level === 0 ? 600 : 500,
  color: level > 0 ? NAVY : 'text.primary',
});

export const getNavChildrenListSx = () => ({
  backgroundColor: `rgba(${NAVY_RGB}, 0.06)`,
  borderRadius: 1,
  mx: 1,
  mb: 1,
  borderLeft: `3px solid ${NAVY}`,
  '& .MuiListItemText-primary': {
    color: NAVY,
    fontWeight: 500,
  },
  '& .MuiListItemIcon-root': {
    color: NAVY,
  },
});
